import React from "react";
import {Typography} from "@mui/material";

import {buildHealthIndicatorIcon, buildSessionHealthColor} from "../../../helpers/HealthIndicatorBuilder";
import ZoomMeetingChip from "../../common/ZoomMeetingChip";
import {CenteredBox, ColoredAvatar} from "../../themes/styled";

export default function MeetingUrlHealth({session, state}) {

    const backgroundColor = buildSessionHealthColor[state];
    const icon = buildHealthIndicatorIcon("meeting-url-creation");

    return (
      <CenteredBox>
          <ColoredAvatar background={backgroundColor}>{icon}</ColoredAvatar>
          <Typography variant="body2" sx={{mr: '-0.75rem'}}>Zoom link</Typography>
          <ZoomMeetingChip zoomMeetingUrl={session?.zoomMeetingUrl} chipStyle={{ marginLeft: '0.5rem' }} />
      </CenteredBox>
    );
}